export const statisticsMock = [
    { label: 'Formations réalisées', value: 128, icon: 'fe fe-book text-primary' },
    { label: 'Bénéficiaires', value: 3200, icon: 'fe fe-users text-success' },
    { label: 'Projets financés', value: 45, icon: 'fe fe-layers text-warning' },
    { label: 'Taux d’avancement (%)', value: 78, icon: 'fe fe-trending-up text-danger' }
]
